"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceContractOrderStatusEnum = void 0;
/** Статус заказа к контракту на услуги */
var UserServiceContractOrderStatusEnum;
(function (UserServiceContractOrderStatusEnum) {
  /** Ожидает исполнения */
  UserServiceContractOrderStatusEnum[UserServiceContractOrderStatusEnum["pending"] = 10] = "pending";
  /** Исполнен */
  UserServiceContractOrderStatusEnum[UserServiceContractOrderStatusEnum["done"] = 20] = "done";
  /** Отменён */
  UserServiceContractOrderStatusEnum[UserServiceContractOrderStatusEnum["canceled"] = 30] = "canceled";
  /** Не смог оплатить */
  UserServiceContractOrderStatusEnum[UserServiceContractOrderStatusEnum["failed"] = 40] = "failed";
})(UserServiceContractOrderStatusEnum = exports.UserServiceContractOrderStatusEnum || (exports.UserServiceContractOrderStatusEnum = {}));
